import { render, staticRenderFns } from "./ProfileContracts.vue?vue&type=template&id=374dee7b"
import script from "./ProfileContracts.vue?vue&type=script&lang=js"
export * from "./ProfileContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports